import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-facultdad-publicidad',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './facultdad-publicidad.component.html',
  styleUrl: './facultdad-publicidad.component.scss'
})
export class FacultdadPublicidadComponent {
  @Input() info:any;
  @Input() language: string = "es";


 url(link: any): string {

    if (!link) return '';

    if (this.isExternalUrl(link)) {
      return link;
    }

    if (link.startsWith('/')) {
      link = link.substring(1);
    }

    return `/${this.language}/${link}`;
  }

  isExternalUrl(urlStr: string): boolean {
    return urlStr.startsWith('http://') || urlStr.startsWith('https://');
  }

}
